export default __webpack_public_path__ + "static/media/header-image.d362c76b.webp";